// Passenger copy follows the original countdown, never the number of offers
// previously sent. A declined offer must not hide the 2- and 4-minute updates.
export function rideNowSearchProgress(ageSeconds) {
  const age = Math.max(0, Number(ageSeconds) || 0);
  if (age >= 285) return "We're making one final check for your driver.";
  if (age >= 240) return "Your search is nearly finished. We're still checking for a driver.";
  if (age >= 150) return "We're still looking. Thanks for your patience.";
  if (age >= 120) return "This is taking a little longer than expected. Our student drivers may be studying right now, but we're still looking.";
  if (age >= 45) return "We're checking nearby student drivers. Your search is still active.";
  return "Looking for available student drivers nearby.";
}
// A separate, short-lived activity line can update without replacing
// the countdown-based reassurance above.
export function rideNowActivityMessage({ reserved = false, connecting = false, hasOffers = false, recentDecline = false } = {}) {
  if (reserved) return "A driver is confirming their availability.";
  if (connecting) return "Checking an available driver.";
  if (hasOffers) return "A driver is reviewing your request.";
  if (recentDecline) return "That driver couldn't take the ride. We're continuing the search.";
  return "";
}
